import { Button, Divider, Grid } from "@mui/material";
import { FieldArray, useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { PhoneLandInput, TextInput } from "../../../../components";
import InvoiceGroupInput from "./InvoiceGroupInput";
import NumberRangeInput from "../../../../components/inputs/NumberRangeInput";
import { paymentTypeEnum } from "../../../../utils/enum";

const PstnPhoneNumbers = () => {
  const { t } = useTranslation();
  const formik: any = useFormikContext();
  return (
    <FieldArray
      name="pstnPhoneNumbers"
      render={(arrayHelpers: any) => (
        <Grid item md={12}>
          {formik.values?.pstnPhoneNumbers?.length > 0 &&
            formik.values.paymentType !== paymentTypeEnum.new &&
            formik.values?.pstnPhoneNumbers?.map((doc: any, index: number) => (
              <div style={{ margin: "15px 0" }}>
                <Grid container spacing={3}>
                  <Grid item md={4}>
                    <PhoneLandInput
                      name={`pstnPhoneNumbers.${index}.phone`}
                      label={t("land_phone")}
                      handleChange={(e: any) => {
                        formik.setFieldValue(
                          `pstnPhoneNumbers.${index}.phone`,
                          e.target.value.replace(/\D/g, "") // removes all non-numeric characters
                        );
                      }}
                    />
                  </Grid>
                  <Grid item md={4}>
                    <NumberRangeInput
                      name_start={`pstnPhoneNumbers.${index}.range_start`}
                      name_end={`pstnPhoneNumbers.${index}.range_end`}
                      label="Numara Aralığı"
                      /* handleChange={(e: any) => {
                        formik.setFieldValue(
                          `pstnPhoneNumbers.${index}.range_start`,
                          e.target.value.replace(/\D/g, "") // removes all non-numeric characters
                        );
                      }} */
                    />
                  </Grid>
                  {/* <Grid item md={4}>
                    <InvoiceGroupInput
                      name={`pstnPhoneNumbers.${index}.invoiceGroupId`}
                      customName={
                        formik?.values?.pstnPhoneNumbers[index].invoiceGroupId
                      }
                    />
                  </Grid> */}
                  <Grid item md={2}>
                    <Button
                      variant="outlined"
                      color="primary"
                      type="button"
                      fullWidth
                      sx={{ height: "50px" }}
                      onClick={() =>
                        arrayHelpers.insert(
                          formik.values.pstnPhoneNumbers.length,
                          {
                            phone: "",
                          }
                        )
                      } // insert an empty string at a position
                    >
                      + PSTN EKLE
                    </Button>
                  </Grid>
                  <Grid item md={1}>
                    {index > 0 && (
                      <Button
                        variant="outlined"
                        color="error"
                        type="button"
                        fullWidth
                        sx={{ height: "50px" }}
                        onClick={() => {
                          arrayHelpers.remove(index);
                        }} // remove a friend from the list
                      >
                        Sil
                      </Button>
                    )}
                  </Grid>
                </Grid>
                <Divider style={{ marginTop: "15px" }} />
              </div>
            ))}
        </Grid>
      )}
    />
  );
};

export default PstnPhoneNumbers;
